module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iaS1sb2NrIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAzMiIgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJub25lIiBzdHJva2U9ImN1cnJlbnRjb2xvciIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBzdHJva2Utd2lkdGg9IjIiPgogICAgPHBhdGggZD0iTTUgMTUgTDUgMzAgMjcgMzAgMjcgMTUgWiBNOSAxNSBDOSA5IDkgNSAxNiA1IDIzIDUgMjMgOSAyMyAxNSBNMTYgMjAgTDE2IDIzIiAvPgogICAgPGNpcmNsZSBjeD0iMTYiIGN5PSIyNCIgcj0iMSIgLz4KPC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/icon-lock.svg
// module id = ct1T
// module chunks = 53